/**
 * Mock registered Meraki keys — used until `/api/meraki/keys/` ships.
 *
 * Default fixture has the user with TWO keys, NONE active — exercises the
 * "activate existing" branch of the page. Flip `active: true` on either to
 * see the "all good" state, or empty the array to see the "create new" state.
 */
import type { MerakiKey } from "@/api/schemas/meraki";

export const MOCK_MERAKI_KEYS: MerakiKey[] = [
  {
    id: 1,
    name: "Eustache · Personal",
    key: "•••• cbc6",
    region: "global",
    active: false,
    createdAt: "2026-01-14T10:21:00Z",
    networkCount: 412,
  },
  {
    id: 2,
    name: "Lab · Shared",
    key: "•••• 9f38",
    region: "global",
    active: false,
    createdAt: "2025-11-02T14:08:00Z",
    networkCount: 18,
  },
];
